import Card from 'components/Card';
import Checkbox from 'components/Checkbox';
import Button from 'components/common/buttons/Button';
import ButtonWithConfirmation from 'components/common/buttons/ButtonWithConfirmation';
import { DataForm } from 'components/formik_inputs';
import DynamicSelect from 'components/formik_inputs/custom-inputs/DynamicSelect';
import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router';
import { fetchCurricula } from '../../../services/curricula-services';
import {
  fetchGrids,
  fetchGridsEquivalences,
} from '../../../services/options_services';
import { fetchGridDisciplines } from 'services/class-services';
import IconTooltip from 'components/IconTooltip';
import {
  createCurriculumEquivalence,
  fetchCurriculumEquivalence,
  deleteCurriculumEquivalence,
  updateCurriculumEquivalence,
} from '../../../services/equivalence_curriculum_service';
import { toast } from 'react-toastify';
import styled from 'styled-components';

const CurricularEquivalenceForm = ({ className }) => {
  const [initialData, setInitialData] = useState(null);
  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    if (id && !initialData) {
      fetchCurriculumEquivalence(id)
        .then((res) => {
          const newData = {
            source: {
              curriculum: { ...res?.grid_discipline?.grid?.curriculum },
              grid: { ...res?.grid_discipline?.grid },
              discipline: { ...res?.grid_discipline },
            },
            target: {
              curriculum: {
                ...res?.equivalent_grid_discipline?.grid?.curriculum,
              },
              grid: { ...res?.equivalent_grid_discipline?.grid },
              discipline: { ...res?.equivalent_grid_discipline },
            },
          };
          setInitialData({ ...newData });
        })
        .catch((err) => {
          if (err.response?.status == 500) {
            toast.error(
              'Ocorreu um erro interno no servidor, entre em contato com nosso suporte.'
            );
            history.push('/equivalencias/curricular');
          } else if (err.response?.status == 404) {
            toast.error('Equivalência não encontrada.');
            history.push('/equivalencias/curricular');
          } else {
            toast.error(
              'Ocorreu um erro inesperado ao carregar a página, entre em contato com nosso suporte.'
            );
            history.push('/equivalencias/curricular');
          }
        });
    }
  }, [id, initialData]);

  const handleSave = async (val) => {
    const bilateralFormData = {
      grid_discipline: 0,
      equivalent_grid_discipline: 0,
    };
    const formData = {
      grid_discipline: val.source.discipline?.id,
      equivalent_grid_discipline: val.target.discipline?.id,
    };
    if (id && initialData) {
      await updateCurriculumEquivalence(id, formData);
      toast.success('Equivalência atualizada com sucesso.');
      history.push('/equivalencias/curricular');
    } else {
      await createCurriculumEquivalence(formData);
      if (val?.bilateral_equivalence) {
        bilateralFormData.grid_discipline = val.target.discipline?.id;
        bilateralFormData.equivalent_grid_discipline =
          val.source.discipline?.id;
        await createCurriculumEquivalence(bilateralFormData)
          .then((res) => {
            toast.success('Equivalência cadastrada com sucesso.');
            history.push('/equivalencias/curricular');
          })
          .catch((err) => {
            if (err.response?.status == 500) {
              toast.error(
                'Ocorreu um erro interno no servidor, entre em contato com nosso suporte.'
              );
              history.push('/equivalencias/curricular');
            } else if (err.response?.status == 404) {
              toast.error('Equivalência não encontrada.');
              history.push('/equivalencias/curricular');
            } else if (err.response?.status == 400) {
              toast.success('Equivalência cadastrada com sucesso.');
              history.push('/equivalencias/curricular');
            } else {
              toast.error(
                'Ocorreu um erro inesperado ao criar um registro de equivalencia curricular, entre em contato com nosso suporte.'
              );
              history.push('/equivalencias/curricular');
            }
          });
      }
    }
  };

  const handleDeleteEquivalence = async () => {
    try {
      await deleteCurriculumEquivalence(id);
      toast.success('Equivalência excluída com sucesso.');
      history.push('/equivalencias/curricular');
    } catch (err) {
      if (err.response.stats == 500) {
        toast.error(
          'Ocorreu um erro interno no servidor, entre em contato com nosso suporte.'
        );
      } else if (err.response.stats == 404) {
        toast.error('Equivalência não encontrada.');
        history.push('/equivalencias/curricular');
      } else {
        toast.error(
          'Ocorreu um erro inesperado ao deletar a equivalência, entre em contato com nosso suporte.'
        );
      }
    }
  };

  if (id && !initialData) {
    return <>Carregando...</>;
  }

  return (
    <div className={className}>
      <Card
        title="Adicionar Equivalência Curricular"
        info={
          'Para criar a equivalência curricular, deverá ser selecionado o currículo x disciplina de origem e o currículo x disciplina de destino/equivalente'
        }
      >
        <DataForm
          autoSetErrors
          initialValues={
            initialData || {
              ...fixedInitialValues,
              bilateral_equivalence: false,
            }
          }
          onSubmit={(val) => handleSave(val)}
        >
          {(formik) => (
            <div className="form-container">
              <DynamicSelect
                label="Curriculo Origem"
                name="source.curriculum"
                fetchFunction={fetchCurricula}
                getOptionValue={(d) => d.id}
                getOptionLabel={(d) => d.name}
                required
              />
              <DynamicSelect
                label="Curriculo Equivalente"
                name="target.curriculum"
                fetchFunction={fetchCurricula}
                getOptionValue={(d) => d.id}
                getOptionLabel={(d) => d.name}
                required
              />
              <DynamicSelect
                required
                label="Etapa Origem"
                placeholder="Selecione um Curriculo de Origem"
                name="source.grid"
                fetchFunction={fetchGrids}
                waitPreSelection={!formik.values.source.curriculum}
                searchParams={{
                  curriculum: formik.values.source.curriculum?.id,
                }}
                getOptionValue={(d) => d.id}
                getOptionLabel={(d) => d.name}
              />
              <DynamicSelect
                required
                label="Etapa Equivalente"
                name="target.grid"
                placeholder="Selecione um Curriculo Equivalente"
                fetchFunction={fetchGridsEquivalences}
                waitPreSelection={!formik.values.target.curriculum}
                searchParams={{
                  curriculum: formik.values.target.curriculum?.id,
                }}
                getOptionValue={(d) => d.id}
                getOptionLabel={(d) => d.name}
              />
              <DynamicSelect
                required
                label="Disciplina Origem"
                name="source.discipline"
                placeholder="Selecione uma Etapa de Origem"
                fetchFunction={fetchGridDisciplines}
                waitPreSelection={!formik.values.source.curriculum}
                searchParams={{
                  curriculum: formik.values.source.curriculum?.id,
                }}
                getOptionValue={(d) => d.id}
                getOptionLabel={(d) => d.discipline?.nome}
              />
              <DynamicSelect
                required
                label="Disciplina Equivalente"
                name="target.discipline"
                placeholder="Selecione uma Etapa Equivalente"
                fetchFunction={fetchGridDisciplines}
                waitPreSelection={!formik.values.target.curriculum}
                searchParams={{
                  curriculum: formik.values.target.curriculum?.id,
                }}
                getOptionValue={(d) => d.id}
                getOptionLabel={(d) => d.discipline?.nome}
              />
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'row',
                }}
              >
                {!id && (
                  <>
                    <Checkbox
                      name="bilateral_equivalence"
                      label="Gravar equivalência bilateral"
                      checked={formik.values.bilateral_equivalence}
                      onChange={() =>
                        formik.setFieldValue(
                          'bilateral_equivalence',
                          !formik.values.bilateral_equivalence
                        )
                      }
                    />
                    <IconTooltip
                      message={
                        'Equivalência bilateral é quando o currículo x disciplina de origem equivale ao currículo x disciplina de destino/equivalente e vice versa.'
                      }
                      icon={'question-circle'}
                      color="#c7c7c7"
                    />
                  </>
                )}
              </div>
              <div className="flutuant-div">
                {Object.keys(formik.errors).length > 0 &&
                  'Erros: Preencha os campos obrigatórios'}
              </div>

              <div className="button-container-delete">
                <Button
                  onClick={() => history.push('/equivalencias/curricular')}
                >
                  Voltar
                </Button>
              </div>
              <div className="button-container">
                {id ? (
                  <ButtonWithConfirmation
                    action="danger"
                    confirmationText="Deseja excluir permanentemente essa Equivalência curricular ?"
                    onClick={() => handleDeleteEquivalence()}
                  >
                    Excluir
                  </ButtonWithConfirmation>
                ) : (
                  <></>
                )}
                <Button type="submit">Salvar</Button>
              </div>
            </div>
          )}
        </DataForm>
      </Card>
    </div>
  );
};

export default styled(CurricularEquivalenceForm)`
  .form-container {
    width: 100%;
    height: 100%;
    display: grid;
    grid-gap: 20px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: repeat(5, 50px);

    .button-container {
      display: flex;
      justify-content: flex-end;

      button {
        width: 30%;
        height: 40px;
      }
    }

    .button-container-delete {
      display: flex;
      justify-content: flex-start;

      button {
        width: 30%;
        height: 40px;
      }
    }

    .flutuant-div {
      width: 100%;
      text-align: left;
      color: rgb(201, 85, 85);
      font-weight: 600;
      font-size: 14px;
    }
  }
`;
const fixedInitialValues = {
  source: { curriculum: null, grid: null, discipline: null },
  target: { curriculum: null, grid: null, discipline: null },
};
